module.exports = __webpack_public_path__ + "static/img/城市智能化1.6f0b684.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buliding/城市智能化1.png
// module id = Rmf3
// module chunks = 1